$('.giveAwayBanner__closeBtn').click(function() {
    $('.giveAwayBanner').addClass('hide');
});
